import { adminSupportQueryKeys as e } from "../supportQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { supportApi as n } from "@maat/api-main";
//#region src/support/admin/useAdminTicketStatsQuery.ts
var r = () => t({
	queryKey: e.ticketStats(),
	queryFn: () => n.adminTicketStats()
});
//#endregion
export { r as useAdminTicketStatsQuery };
